import { Route, Switch } from 'react-router-dom';
import LocalizationProvider from '@guestyci/localize/LocalizationProvider';

import RegistrationLayout from 'app/RegistrationLayout';
import StepsHeader from 'app/components/StepsHeader';
import * as appRoutes from 'app/routes';
import RouteDioPageView from 'app/hooks/useDioUtils';

import ChooseSignupPage from 'app/pages/ChooseSignupPage';
import RegistrationPage from 'app/pages/RegistrationPage';
import MailSentInfoPage from 'app/pages/MailSentInfoPage';
import ThankYouContentPage from 'app/pages/ThankYouContentPage';
import ExistingEmailContentPage from 'app/pages/ExistingEmailContentPage';
import ExtendTrialPage from 'app/pages/ExtendTrialPage';
import VerificationError from 'app/pages/VerificationError';
import NotFound from 'app/pages/NotFound';

const App = () => (
  <LocalizationProvider>
    <RegistrationLayout>
      <RouteDioPageView />
      <Route path={appRoutes.crumbs} exact component={StepsHeader} />
      <Switch>
        <Route path={appRoutes.ROOT} exact component={ChooseSignupPage} />
        <Route path={appRoutes.FORM} exact component={RegistrationPage} />
        <Route path={appRoutes.VERIFY_EMAIL} exact component={MailSentInfoPage} />
        <Route path={appRoutes.ACTIVATE} exact component={ThankYouContentPage} />
        <Route path={appRoutes.EXTEND_TRIAL} exact component={ExtendTrialPage} />
        <Route path={appRoutes.EXISTING_EMAIL} exact component={ExistingEmailContentPage} />
        <Route path={appRoutes.VERIFICATION_ERROR} exact component={VerificationError} />
        <Route path="*" component={NotFound} />
      </Switch>
    </RegistrationLayout>
  </LocalizationProvider>
);

export default App;
